import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { LogoMark } from "@/components/Logo";

const NotFoundPage = () => (
  <div
    className="grain-overlay relative flex min-h-[80vh] flex-col items-center justify-center bg-navy-950 px-6 pt-20 text-center"
    data-testid="not-found-page"
  >
    <LogoMark className="h-20 w-auto rounded-xl" />
    <p className="mt-10 font-serif text-8xl font-bold sm:text-9xl">
      <span className="gold-text-gradient">404</span>
    </p>
    <h1 className="mt-4 font-serif text-2xl font-bold text-white sm:text-3xl">This Page Has Gone Off Duty</h1>
    <p className="mt-3 max-w-md text-slate-400">
      The page you are looking for doesn't exist or has been moved. Let us guide you back.
    </p>
    <Link
      to="/"
      data-testid="not-found-home-btn"
      className="group mt-9 inline-flex items-center gap-2 rounded-full bg-gold px-7 py-3 text-sm font-bold uppercase tracking-wider text-navy-950 transition-all duration-300 hover:bg-gold-light"
    >
      <ArrowLeft className="h-4 w-4 transition-transform duration-300 group-hover:-translate-x-1" />
      Back to Home
    </Link>
  </div>
);

export default NotFoundPage;
